import { NO_CACHE_PARAM } from 'defs/http/cache';
import { PREVIEW_USER } from 'defs/http/headers';
import axios, { AxiosResponse } from 'helper/axios-facade';
import appConfig from 'helper/mapBackendConfig';
import moment from 'moment';
import { ProgramOverviewItemType } from 'store/programOverview';

export type ProgramOverviewResponseType = ProgramOverviewItemType[];

const todaysDate = moment().format('YYYY[-]MM[-]DD');

export const startProgram = (programTemplate: Object): Object => {
	const requestUrl = `${appConfig.env.urlSpringAPI}/programs/start`;
	return axios.post(requestUrl, programTemplate);
};

export const startProgramAsPreviewUser = (programTemplate: Object, date: string): Object => {
	const requestUrl = `${appConfig.env.urlSpringAPI}/programs/overwrite/preview?date=${date || todaysDate}`;

	return axios.post(requestUrl, programTemplate);
};

export const overwriteProgram = (programTemplate: Object): Object => {
	const requestUrl = `${appConfig.env.urlSpringAPI}/programs/overwrite`;
	return axios.post(requestUrl, programTemplate);
};

export const deleteProgram = (programId: string): Object => {
	const requestUrl = `${appConfig.env.urlSpringAPI}/programs/${programId}`;
	return axios.delete(requestUrl);
};

export const fetchProgramTemplate = (programId: string, previewUser: boolean): Object => {
	let requestUrl = `${appConfig.env.urlMagnoliaAPICoach}/programs/${programId}/template.json`;
	requestUrl = previewUser ? `${requestUrl}?${NO_CACHE_PARAM}` : requestUrl;

	return axios.get(requestUrl, {
		withCredentials: false,
		headers: {
			[PREVIEW_USER]: !!previewUser,
		},
	});
};

export const fetchProgramPreview = (programId: string, previewUser: boolean): Object => {
	let requestUrl = `${appConfig.env.urlMagnoliaAPICoach}/programs/${programId}.json`;
	requestUrl = previewUser ? `${requestUrl}?${NO_CACHE_PARAM}` : requestUrl;

	return axios.get(requestUrl, {
		withCredentials: false,
		headers: {
			[PREVIEW_USER]: !!previewUser,
		},
	});
};

export const fetchProgramOverview = (previewUser: boolean): Promise<AxiosResponse<ProgramOverviewResponseType>> => {
	let requestUrl = `${appConfig.env.urlMagnoliaAPICoach}/programs.json`;
	requestUrl = previewUser ? `${requestUrl}?${NO_CACHE_PARAM}` : requestUrl;

	return axios.get(requestUrl, {
		withCredentials: false,
		headers: {
			[PREVIEW_USER]: !!previewUser,
		},
	});
};

export const fetchActivePrograms = (): Object | void => {
	const requestURL = `${appConfig.env.urlSpringAPI}/programs/active`;

	return axios.get(requestURL);
};

export const finishProgram = (programId: string): Object => {
	const requestUrl = `${appConfig.env.urlSpringAPI}/programs/${programId}/finish`;
	return axios.put(requestUrl);
};
